import { ReactNode, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";
import SubHeader from "../SubHeader";
import HeaderDetails from "./HeaderDetails";
import "./styles.css";
import { AuthContext } from "../../../contexts/Authentication/AuthContext";

export default function Header({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const { mode } = useParams();
  const {account} = useContext(AuthContext);
  const { titlePage } = useContext(DashboardContext);

  useEffect(() => {
    if (mode !== "edit") setIsOpen(false);
  }, [mode]);

  useEffect(() => {
    if (titlePage) {
      document.title = titlePage + " - Torre Logística de Entregas - TLE - " + account;
    }
  }, [titlePage]);

  return (
    <>
      <div className="row header">
        {mode !== "edit" ? (
          <div className="accordion">
            <div
              className={`accordion__header ${
                isOpen ? "accordion__header--hidden" : ""
              }`}
            >
              <HeaderDetails
                isOpen={false}
                isVisible={!isOpen}
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              />
            </div>
            <div
              className={`accordion__content ${
                isOpen ? "accordion__content--open" : ""
              }`}
            >
              <HeaderDetails
                isOpen={true}
                isVisible={isOpen}
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              />
            </div>
          </div>
        ) : (
          <HeaderDetails isOpen={true} isVisible={true} />
        )}
      </div>
      <div
        className={`${
          mode === "edit"
            ? "header"
            : "sub-header" + `${isOpen ? "sub-header--open" : ""}`
        }`}
      >
        <SubHeader />
      </div>
      {children}
    </>
  );
}
